module.exports = __webpack_public_path__ + "static/media/quote-tail.befc421a.svg";